import { Col, ControlLabel, Row } from 'react-bootstrap';
import React from 'react';
import { Field } from 'react-final-form';

import OrgGroupStakeholdersBulkSelect from './SelectFields/OrgGroupStakeholdersBulkSelect.jsx';
import StakeholderParticipants from './SelectFields/StakeholderParticipants.jsx';
import FieldGroup from '../FieldGroup.jsx';
import IndividualStakeholdersBulkSelect from './SelectFields/IndividualStakeholdersBulkSelect.jsx';
import CustomRadio from '../CustomRadio.jsx';

export const uploadMethodOptions = [
  { label: 'Add Manually', value: 'manually' },
  { label: 'Bulk CSV Upload', value: 'csv' },
];

export const replaceOptions = [
  { label: 'Add new stakeholder to an existing structure', value: 'add' },
  { label: 'Replace existing structure', value: 'replace' },
];

const StakeholdersSelect = ({
  orgStakeholders,
  selectedGroupStakeholders,
  updateSelectedGroupStakeholders,
  selectedIndividuals,
  updateSelectedIndividuals,
  uploadMethod,
  replaceMethod,
  setUploadMethod,
  setReplaceMethod,
  currentCSVDownloadButton,
  exampleCSVDownloadButton,
  editing,
}) => {
  const additionalFields = {
    individuals: [],
  };

  const handleRemoveGroupStakeholder = (id) => {
    if (window.confirm('Are you sure you want to detach this stakeholder?')) {
      updateSelectedGroupStakeholders(
        selectedGroupStakeholders.filter((group) => group.id !== id)
      );
    }
  };

  const isDisabledIndividual = (id) => {
    return (
      selectedGroupStakeholders.some((group) =>
        group.individuals.includes(id)
      ) || selectedIndividuals.includes(id)
    );
  };

  return (
    <React.Fragment>
      <p className="text-muted m-b-24">
        Upload a CSV or add Stakeholder(s) manually.
      </p>
      <div className="m-b-18">
        <CustomRadio
          name="stakeholdersUploadMethod"
          checkedValue={uploadMethod}
          options={uploadMethodOptions}
          action={setUploadMethod}
        />
      </div>

      {uploadMethod === 'csv' ? (
        <React.Fragment>
          {selectedGroupStakeholders.length || selectedIndividuals.length ? (
            <Row className="m-b-48">
              <Col xs={12}>
                <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                  <h3>Existing Structure</h3>
                </div>
              </Col>
              <Col xs={12}>
                <div className="m-b-18">
                  <CustomRadio
                    name="stakeholdersReplaceMethod"
                    checkedValue={replaceMethod}
                    options={replaceOptions}
                    action={setReplaceMethod}
                  />
                </div>
              </Col>
              <Col xs={12}>{editing ? currentCSVDownloadButton : null}</Col>
            </Row>
          ) : null}
          <Row>
            <Col xs={12}>
              <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                <h3>Bulk CSV Upload</h3>
              </div>
            </Col>
            <Col xs={12}>
              <div className="m-b-18">{exampleCSVDownloadButton}</div>
            </Col>
            <Col xs={12}>
              <Field
                id="stakeholdersFormCsvFile"
                name="csv_stakeholders_file"
                type="file"
                component={FieldGroup}
                accept=".csv"
              />
            </Col>
          </Row>
        </React.Fragment>
      ) : null}

      {uploadMethod === 'manually' ? (
        <React.Fragment>
          <ControlLabel>
            Select Group Stakeholder(s)
            <strong className="bordered bordered-xs text-muted m-l-8">
              Total:&nbsp;
              <span className="text-info-brand count">
                {selectedGroupStakeholders.length}
              </span>
            </strong>
          </ControlLabel>

          <Row>
            <Col xs={12}>
              <OrgGroupStakeholdersBulkSelect
                orgStakeholders={orgStakeholders}
                selectedGroupStakeholders={selectedGroupStakeholders}
                updateSelectedGroupStakeholders={
                  updateSelectedGroupStakeholders
                }
                additionalFields={additionalFields}
                handleRemove={handleRemoveGroupStakeholder}
              />
            </Col>
            <Col xs={12}>
              {selectedGroupStakeholders.map((stakeholder, index) => {
                return (
                  <React.Fragment key={stakeholder.id}>
                    <StakeholderParticipants
                      index={index}
                      editing={editing}
                      stakeholder={stakeholder}
                      orgStakeholders={orgStakeholders}
                      selectedGroupStakeholders={selectedGroupStakeholders}
                      updateSelectedGroupStakeholders={
                        updateSelectedGroupStakeholders
                      }
                      isDisabled={isDisabledIndividual}
                      handleRemove={handleRemoveGroupStakeholder}
                    />
                  </React.Fragment>
                );
              })}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <IndividualStakeholdersBulkSelect
                orgStakeholders={orgStakeholders}
                selectedIndividuals={selectedIndividuals}
                updateSelectedIndividuals={updateSelectedIndividuals}
                isDisabled={isDisabledIndividual}
              />
            </Col>
          </Row>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};

export default StakeholdersSelect;
